import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../configurations/config";

const TicketActionFormatter = ({ ticketId, currentPage, ticketStatus }) => {
	return (
		<div>
			<Link
				to={{
					pathname: `${Routes.CMTicketApproval}/${ticketId}`,
					state: {
						currentPage,
						redirectUrl: Routes.CMCMAssignedTickets,
						ticketStatus,
					},
				}}
			>
				<button className="btnStyle" title="View Detail">
					<FontAwesomeIcon
						id="edit"
						className="hoverEffect"
						icon={faEye}
						size="1x"
					/>
				</button>
			</Link>
		</div>
	);
};

export default TicketActionFormatter;
